import './i18n';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';

import AppRoot from './AppRoot';
import { LanguageProvider } from './shared/contexts/LanguageContext';

// -----------------------------------------------
// Contexts
// -----------------------------------------------
import { AuthProvider } from './shared/contexts/AuthContext';
import { LocationProvider } from './shared/contexts/useLocationContext';
import { MediaPreviewProvider } from './shared/contexts/MediaPreviewContext';
import { LikesProvider } from './shared/contexts/LikesContext';
import { SocketProvider}  from "./shared/socket/SocketProvider";
import { ActiveChatsProvider}  from "./shared/contexts/ActiveChatsContext";
import { ChatProvider}  from "./shared/contexts/ChatContext";



const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <LanguageProvider>
    <AuthProvider>
      <SocketProvider>
        <ChatProvider>
        <ActiveChatsProvider>
        <MediaPreviewProvider>
          <LikesProvider>
            <LocationProvider>
              <AppRoot />
            </LocationProvider>
          </LikesProvider>
        </MediaPreviewProvider>
        </ActiveChatsProvider>
        </ChatProvider>
      </SocketProvider>
    </AuthProvider>
  </LanguageProvider>
);